// extracted by mini-css-extract-plugin
export var editInput = "_fo-0";
export var editInputCompact = "_fo-2";
export var editInputLarge = "_fo-1";
export var editInputSmall = "_fo-3";